import React from 'react';

const TopCustomersFunnel = ({ data, onCustomerClick }) => {
  // Take top 5 customers
  const topData = data.slice(0, 5);

  if (topData.length === 0) {
    return <div className="text-gray-500 text-center py-8">No customer data available</div>;
  }

  // Gradient colors from teal to blue-purple
  const colors = [
    '#0d9488', // Teal-600 (largest)
    '#14b8a6', // Teal-500
    '#06b6d4', // Cyan-500
    '#0ea5e9', // Sky-500
    '#6366f1', // Indigo-500 (smallest)
  ];

  const handleClick = (item) => {
    if (onCustomerClick && item.customer) {
      onCustomerClick(item.customer);
    }
  };

  const isClickable = !!onCustomerClick;

  return (
    <div className="w-full flex flex-col items-center py-3">
      {/* Funnel sections */}
      <div className="w-full flex flex-col items-center gap-1">
        {topData.map((customer, index) => {
          // Calculate width decreasingly from 100% to 40%
          const widthPercent = 100 - (index * 15);

          return (
            <div
              key={index}
              onClick={() => handleClick(customer)}
              className={`relative flex items-center justify-center transition-all duration-300 hover:brightness-110 ${isClickable ? 'cursor-pointer' : 'cursor-default'}`}
              style={{
                width: `${widthPercent}%`,
                height: '48px',
                backgroundColor: colors[index % colors.length],
                clipPath: index === 0
                  ? 'polygon(0 0, 100% 0, 96% 100%, 4% 100%)'
                  : index === topData.length - 1
                  ? 'polygon(4% 0, 96% 0, 92% 100%, 8% 100%)'
                  : 'polygon(4% 0, 96% 0, 92% 100%, 8% 100%)',
                borderRadius: index === 0 ? '8px 8px 0 0' : index === topData.length - 1 ? '0 0 8px 8px' : '0',
              }}
              title={isClickable ? `View ${customer.name}'s orders` : undefined}
            >
              <span className="text-white font-bold text-lg z-10 select-none">
                {customer.orders}
              </span>
            </div>
          );
        })}
      </div>

      {/* Labels below the funnel */}
      <div className="w-full mt-5 space-y-2.5 px-2">
        {topData.map((customer, index) => (
          <div
            key={index}
            onClick={() => handleClick(customer)}
            className={`flex items-center justify-between rounded-lg px-2 py-1 transition-colors ${
              isClickable ? 'cursor-pointer hover:bg-gray-50 active:bg-gray-100' : ''
            }`}
          >
            <div className="flex items-center gap-2.5 min-w-0">
              <div
                className="w-3.5 h-3.5 rounded-full flex-shrink-0"
                style={{ backgroundColor: colors[index % colors.length] }}
              />
              <span className="text-sm font-semibold text-gray-800 truncate">
                {customer.name}
              </span>
            </div>
            <span className="text-sm text-gray-500 font-medium ml-2 flex-shrink-0">
              {customer.orders} {customer.orders === 1 ? 'order' : 'orders'}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TopCustomersFunnel;
